import React, { Component } from 'react';
import { MDBInput } from 'mdbreact';
/*RQTO. CRÉDITO DIGITAL FASE II*/
import { GrabarSimulacion_, ProductosEncryptionKeyGET_, ProductosUrlDireccionGET_ } from '../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import Loading from '../Loading';

class FormAsesoriaDigital extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            estadoSolicitud: true,
            tipoiden: 'DEFAULT',
            montoreq: '',
            nit: '',
            stateLoadign: false,
            idprodserv: '',
            //RQTO. CRÉDITO DIGITAL FASE II 2026
            prolinea: this.props.prolinea,
        };
    }

    componentDidMount() {
        //RQTO. CRÉDITO DIGITAL FASE II 2026
        let nuevoValor = null;
        
        if (this.props.idprodserv === "Ahorros") {
            nuevoValor = "1";
            
        } else if (this.props.idprodserv === "Credito") {
            nuevoValor = "0";
        }

        //RQTO. CRÉDITO DIGITAL FASE II 2026
        if (nuevoValor !== null) this.setState({ idprodserv: nuevoValor });
    }

    //RQTO. CRÉDITO DIGITAL FASE II
    validateInput = () => {
        const e = {};
        if (this.state.tipoiden === 'DEFAULT') {
            e.tipoiden = "¡Debes seleccionar un tipo de identificación!";
        }
        if (!this.state.nit === this.state.nit.trim() === "") {
            e.nit = "¡Debes ingresar un número de identificación.!"
        }
        this.setState({ errors: e });

        return Object.keys(e).length === 0;
    }

    //RQTO. CRÉDITO DIGITAL FASE II
    textInput = (e) => {
        const { name, value } = e.target;

        if (name === "nit") {
            const regex = /^[a-zA-Z0-9]+$/;
            if (!regex.test(value) && value !== "") return;
        }

        this.setState({ [name]: value }, () => {
            const { tipoiden, nit } = this.state;
            const isFormValid = tipoiden !== 'DEFAULT' && nit.trim() !== "";
            this.setState({ estadoSolicitud: !isFormValid });
        })
    }

    //RQTO. CRÉDITO DIGITAL FASE II
    sendForm = () => {
        const { tipoiden, nit, } = this.state;
        const { montoSimulado, interes_ahorro, valor_renta, gmf, plazoSimulado, tasa_n_anual, tasa_e_anual, prolineahorros } = this.props;

        //RQTO. CRÉDITO DIGITAL FASE II
        const isValid = this.validateInput();
        if (!isValid) return;

        // formulario validado
        this.setState({
            stateLoadign: true,
            estadoSolicitud: true,
        });
        const data = {
            tran: 1,
            idproceso: 0,
            tipoiden: tipoiden,
            nit: nit,

            tipooper: parseInt(this.state.idprodserv),

            prolinea: parseInt(prolineahorros),
            monto: montoSimulado === '' ? 0 : parseFloat(montoSimulado.replace(/\./g, '')),
            plazo: parseInt(plazoSimulado),
            tasae: tasa_e_anual,
            tasan: tasa_n_anual,
            idcanal: 1,
            train: 0,
            fecvenci: new Date().toISOString(),
            intgenerado: parseFloat(interes_ahorro.replace(/\./g, '')),
            retencion: parseFloat(valor_renta.replace(/\./g, '')),
            gmf: parseFloat(gmf.replace(/\./g, '')),
            idmaestro: 0,
            tipoinversion: 1,
            estado: 0
        }

        //RQTO. CRÉDITO DIGITAL FASE II 2026 - NUEVA FUNCIÓN
        const firstCharToUpperCase = (str) => {
            if (!str) return '';
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }

        GrabarSimulacion_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        const xmlString = response.data; 
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(xmlString, "application/xml");
                        const codigo = xmlDoc.getElementsByTagName("codresp")[0]?.textContent;
                        const mensaje = xmlDoc.getElementsByTagName("desresp")[0]?.textContent;

                        if (codigo !== "000000") {
                            this.setState({
                                estadoSolicitud: false
                            })
                           //RQTO. CRÉDITO DIGITAL FASE II - JPGM 2026
                            Swal.fire({
                                icon: 'warning',
                                title: '¡Advertencia!',
                                text: firstCharToUpperCase(mensaje),
                                allowOutsideClick: false,
                                showCancelButton: false,
                                confirmButtonColor: "#F48C24",
                                confirmButtonText: "Aceptar"
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.reload();
                                }
                            });
                            //FIN
                        }
                        //RQTO. CRÉDITO DIGITAL FASE II 2026
                        //else {
                        else if ( codigo === "000000") {
                            this.setState({
                                estadoSolicitud: true,
                            });
                            Swal.fire({
                                icon: 'success',
                                text: mensaje,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    const dataUrlDireccion = {
                                        tran: 5,
                                        idurl: 0,
                                        direccionurl: "N/A",
                                        identificador: "PaginaWeb",
                                        ambiente: 1,
                                        estado: 1
                                    }
                                    const param = this.state.idprodserv === "0" ? 3 : 5;
                                    const dataEncryptio = { parametros: `param=${param}&option=${prolineahorros}` };

                                    Promise.all([ProductosUrlDireccionGET_(dataUrlDireccion), ProductosEncryptionKeyGET_(dataEncryptio)])
                                    .then(([response1, response2]) => {
                                        const urlDigital = response1.data;
                                        const urlEncrypt = response2.data;
                                        const urlArmada = urlDigital + urlEncrypt;

                                        //Verificamos que ambos tengan datos
                                        if (urlDigital && urlEncrypt) {
                                            this.setState({
                                                urlDigital: urlDigital,
                                                urlEncrypt: urlEncrypt
                                            }, () => {
                                                window.location.href = urlArmada;
                                            });
                                        } else {
                                            console.error("Alguno de los datos está vacío");
                                        }
                                    })
                                    .catch(error => {
                                        //console.error("Error en una de las solicitudes:", error);
                                    });
                                }
                            });
                        }
                    }
                } else {
                    this.setState({
                        estadoSolicitud: false,
                    })
                    Swal.fire({
                        icon: 'error',
                        text: response,
                    })
                }

            } catch (error) {
                //console.log(error);
            }
        });
    }

    render() {
        const { errors } = this.state;

        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-6 border-bottom" style={{ marginBlockEnd: 'auto', background: 'none' }}>
                            <p className="font-weight-bold mb-0 pb-0">Tipo de Documento <b className="text-danger">*</b></p>

                            <select name="tipoiden" className="form-control mt-2 border-0 border-bottom" value={this.state.tipoiden} onChange={this.textInput} style={{ background: 'none' }}>
                                <option value={'DEFAULT'} disabled>Seleccione...</option>
                                <option value="C">Cédula de Ciudadania</option>
                                {/*RQTO. CRÉDITO DIGITAL FASE II 2026 - CAMBIAR codlinea 49 POR 51 EN PRODUCCIÓN*/}
                                <option style={{ display: `${this.props.prolinea === 51 ? 'none': 'auto'}` }} value="E">Cédula de Extranjería</option>
                                <option style={{ display: `${this.props.prolinea === 51 ? 'none' : 'auto'}` }} value="N">NIT</option>
                                <option style={{ display: `${this.props.prolinea === 51 ? 'none' : 'auto'}` }} value="P">Pasaporte</option>
                                {/*FIN*/}
                            </select>
                            {errors.tipoiden && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.tipoiden}</strong>}
                        </div>

                        <div className="col-12 col-md-6 mb-4">
                            <p className="font-weight-bold mb-0 pb-0">Documento de Identidad <b className="text-danger">*</b></p>
                            {/*RQTO. CRÉDITO DIGITAL FASE II*/}
                            {/*<div onClick={this.activeButton}>*/}
                            <div>
                                <MDBInput maxLength="20" name="nit" value={this.state.nit} label="Ingrese su número de documento" type="text" onChange={this.textInput} />
                            </div>
                            {errors.nit && <strong className="text-danger d-block mt-1" style={{ fontSize: '13px' }}>{errors.nit}</strong>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex justify-content-end">
                            <button className="btn px-4 py-2" onClick={this.sendForm} disabled={this.state.estadoSolicitud} style={{ background: this.props.color, color: 'white', borderRadius: '15px' }}> Solicitud </button>
                        </div>
                    </div>
                </div>
             
                {this.state.stateLoadign ? (
                    <Loading />
                ) : (<React.Fragment></React.Fragment>)}
            </React.Fragment>
        );
    }
}

export default FormAsesoriaDigital;